/**
 * PDF do regulamento oficial do torneio, mostrado no briefing de torneios.
 * Enquanto estiver vazio, o card aparece como "Disponível em breve".
 */
export const TOURNAMENT_RULES_PDF_URL =
  'https://fuzzyplaydev.s3.us-east-2.amazonaws.com/regulamentos-frl/Regulamento+FRL+2026+-+v1.2.pdf';
